var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.item
    ? _c("img", {
        class: _vm.$style.itemImage,
        attrs: { src: _vm.itemToImageMapper(_vm.item), alt: "" }
      })
    : _c("div", { staticClass: "no-item-placeholder" })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/apps/configurator/components/Preview/ItemPreview.vue?vue&type=template&id=1f682d8b&
// module id = null
// module chunks = 